import { createSlice } from "@reduxjs/toolkit";

const featureFlagSlice = createSlice({
  name: "featureFlag",
  initialState: {
    extras: {
      medicCertificate: true,
      expressDelivery: true,
      ordinaryMailDelivery: false,
    },
  },
  reducers: {
    applyFeatureFlag(state, action) {
      state.featureFlag = action.payload;
    },
  },
});

export const featureFlagActions = featureFlagSlice.actions;

export default featureFlagSlice;
